import { _ as _setPrototypeOf } from './setPrototypeOf-74b63dd9.js';

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}

export { _inheritsLoose as _ };
